'use client';

import { BackHeader, GuidesButton } from '@insta-club/ui';
import { Container } from 'src/libs/components/layout';

interface IProps extends React.PropsWithChildren {
    title?: string | React.ReactNode;
    description?: {
        title?: string;
        text: string;
        link?: string;
    };
    showBackButton?: boolean;
    guideKey?: string;
}

function AuthLayout({ children, title = 'ورود و ثبت نام', description, guideKey, showBackButton = false }: IProps) {
    const renderDescription = () => {
        return (
            <>
                {description?.title && (
                    <div className='mt-9 flex items-center justify-between'>
                        {typeof description?.title === 'string' ? (
                            <span className='text-[32px] font-bold text-gray-800'>{description?.title}</span>
                        ) : (
                            description?.title
                        )}

                        {guideKey ? <GuidesButton guideKey={guideKey} /> : null}
                    </div>
                )}
                <p className='mt-9 mb-6 text-sm leading-6 font-semibold text-gray-500'>{description?.text}</p>
            </>
        );
    };
    return (
        <>
            <BackHeader title={title} showBackButton={showBackButton} />
            <Container hasHeader>
                {description && renderDescription()}
                {children}
            </Container>
        </>
    );
}

export default AuthLayout;

